import { render, staticRenderFns } from "./CardPage.vue?vue&type=template&id=18733b52&scoped=true&"
import script from "./CardPage.vue?vue&type=script&lang=js&"
export * from "./CardPage.vue?vue&type=script&lang=js&"
import style0 from "./CardPage.vue?vue&type=style&index=0&lang=stylus&"
import style1 from "./CardPage.vue?vue&type=style&index=1&id=18733b52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18733b52",
  null
  
)

export default component.exports